import {ChessGame} from "@react-chess-tools/react-chess-game";
import {ChessBot} from "@react-chess-tools/react-chess-bot";
import {AdBanner} from '../adBanner/AdBanner';
import './PlayPage.css';
import {useState} from "react";

export function PlayPage() {
    const [level, setLevel] = useState(4);
    const isProduction = process.env.NODE_ENV === 'production';
    const workerPath = isProduction
        ? "/stockfish-worker.js"
        : "/stockfish.js";
    return (
        <div className="play-page">
            <div className="play-wrapper">
                <h1 className="page-title">Игра с ботом</h1>

                <div className="level-control">
                    <label>Уровень сложности: {level - 3}</label>
                    <input
                        type="range"
                        min="4"
                        max="8"
                        value={level}
                        onChange={(e) => setLevel(Number(e.target.value))}
                    />
                </div>

                <div className="chess-container">
                    <ChessGame.Root fen="rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR w KQkq - 0 1">
                        <ChessGame.Board />
                        <ChessBot.Player
                            color="b"
                            strength={{ level: level }}
                            variability="medium"
                            workerOptions={{ workerPath, threads: 1 }}
                        />
                    </ChessGame.Root>
                </div>
                <AdBanner />
            </div>
        </div>
    );
}
